// src/pages/Notifications/index.js
import React from 'react';
import { useApp } from '../../context/AppContext';
import { SimpleHeader } from '../../components/layout/Header';
import { BellIcon, StarIcon, ChevronRightIcon } from '../../components/common/Icons';

const NotificationItem = ({ icon, title, subtitle, date, onClick }) => {
  return (
    <div className="flex items-start p-4 border-b" onClick={onClick}>
      <div className="w-12 h-12 rounded-full flex items-center justify-center mr-3">
        {icon}
      </div>
      <div className="flex-1">
        <div className="flex items-start justify-between">
          <div>
            <div className="font-medium">{title}</div>
            <p className="text-gray-600 text-sm">{subtitle}</p>
          </div>
          <ChevronRightIcon size={20} className="text-gray-400 mt-1 ml-2" />
        </div>
        <div className="text-gray-500 text-sm mt-1">{date}</div>
      </div>
    </div>
  );
};

const Notifications = () => {
  const { navigateTo } = useApp();

  // Notificări exemplu
  const notifications = [
    {
      id: 1,
      type: 'review',
      title: 'Lasă o recenzie!',
      subtitle: 'Evaluează serviciile oferite de Eugen Ciprian Grigore de la Frizerie cu Stil și Coafor Focsani.',
      date: '15 feb. 2025',
      icon: <StarIcon size={24} fill="#F9A826" stroke="#F9A826" />
    },
    {
      id: 2,
      type: 'reminder',
      title: 'Frizerie cu Stil și Coafor Focsani',
      subtitle: 'îți reamintește ca ai programare sâmbătă 15 feb. ora 14:45.',
      date: '15 feb. 2025',
      icon: <BellIcon size={24} className="text-purple-500" />
    },
    {
      id: 3,
      type: 'reminder',
      title: 'Frizerie cu Stil și Coafor Focsani',
      subtitle: 'îți reamintește ca ai programare sâmbătă 15 feb. ora 14:45.',
      date: '14 feb. 2025',
      icon: <BellIcon size={24} className="text-purple-500" />
    },
    {
      id: 4,
      type: 'review',
      title: 'Lasă o recenzie!',
      subtitle: 'Evaluează serviciile oferite de Eugen Ciprian Grigore de la Frizerie cu Stil și Coafor Focsani.',
      date: '9 dec. 2024',
      icon: <StarIcon size={24} fill="#F9A826" stroke="#F9A826" />
    },
    {
      id: 5,
      type: 'review',
      title: 'Lasă o recenzie!',
      subtitle: 'Evaluează serviciile oferite de Eugen Ciprian Grigore de la Frizerie cu Stil și Coafor Focsani.',
      date: '5 dec. 2024',
      icon: <StarIcon size={24} fill="#F9A826" stroke="#F9A826" />
    }
  ];

  // Handler pentru click pe notificare
  const handleNotificationClick = (notification) => {
    if (notification.type === 'review') {
      // Navigare la ecranul de recenzii
      console.log('Navigate to review screen');
    } else if (notification.type === 'reminder') {
      // Navigare la detaliile programării
      console.log('Navigate to appointment details');
    }
  };

  // Popup pentru activarea notificărilor
  const NotificationPopup = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-4">
        <div className="flex justify-end">
          <button className="text-gray-500">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        <h2 className="text-xl font-bold text-center mb-2">Nu rata lucrurile importante</h2>
        <p className="text-center mb-6">Activează notificările push și primește actualizări ale programărilor în timp real</p>
        
        <button className="w-full bg-blue-600 text-white py-3 rounded-full font-medium">
          Activează notificările
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex-1 overflow-y-auto pb-16">
      <SimpleHeader title="Notificări" onBack={() => navigateTo('home')} />
      
      <div className="divide-y">
        {notifications.map(notification => (
          <NotificationItem 
            key={notification.id}
            icon={notification.icon}
            title={notification.title}
            subtitle={notification.subtitle}
            date={notification.date}
            onClick={() => handleNotificationClick(notification)}
          />
        ))}
      </div>
      
      {/* Exemplu de afișare a popup-ului, poți adăuga o logică de state pentru a-l arăta condițional */}
      {/* <NotificationPopup /> */}
    </div>
  );
};

export default Notifications;